export default "__VITE_ASSET__Cc5mfZhH__"